





















import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentFeed, ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import WithAuthUser from "@/mixins/WithAuthUser";
import { CheckAuthorities } from "@/lib/decorators";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { shareUrl } from "@/lib/urlHelpers";
import { BaseMenuItem } from "@/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseList, { BaseListItem } from "@/components/BaseList";
import BaseMenu from "@/components/BaseMenu";

@Component({ name: "ContentFeedItemMenu", components: { BaseMenu, BaseList, BaseListItem, BaseConfirm, BaseButton } })
export default class ContentFeedItemMenu extends mixins(WithAuthUser) {
  @Prop({ type: Object, required: true })
  public readonly contentFeed!: ContentFeed;

  @Prop({ type: Boolean, default: true })
  public readonly showReportItem!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showShare!: boolean;

  @Prop({ type: String, required: true })
  public readonly shareLink!: string;

  @Prop({ type: String })
  public readonly activatorClass!: string;

  public get canUpdateContentSet() {
    return (
      this.contentFeed.type !== ContentFeedTypeEnum.STORY &&
      checkAuthorities(this.authUserAuthorities, this.isAuthor ? ["updateMyContentSet"] : ["updateAnyContentSet"])
    );
  }

  @CheckAuthorities(ctx => (ctx.isAuthor ? ["deleteMyContentSet"] : ["deleteAnyContentSet"]))
  public canDeleteContentSet!: boolean;

  public showReportConfirm = false;

  public get processingError() {
    return (
      this.contentFeed.processingStatus === "ERROR" && this.authUser && this.authUser.id === this.contentFeed.userId
    );
  }

  public get iconName() {
    return this.processingError ? "sci-color-error" : "sci-dots-vertical";
  }

  public get menuItems() {
    let menuItems: BaseMenuItem[] = [];
    if (this.showShare) {
      menuItems.push({
        name: "share",
        class: "feed-item__menu__share",
        text: $t("Share"),
      });
    }
    if (this.canUpdateContentSet)
      menuItems.push({
        name: "edit-post",
        text: $t("Edit"),
        prependIcon: this.processingError ? "sci-color-error" : undefined,
      });
    if (this.canDeleteContentSet)
      menuItems.push({
        name: "delete-post",
        text: $t("Delete"),
      });
    if (this.showReportItem) {
      menuItems.push({
        name: "report-post",
        text: $t("Report"),
      });
    }
    return menuItems;
  }

  public get isAuthor(): boolean {
    return (this.authUser && this.authUser.id === this.contentFeed.userId) || false;
  }

  public onEditPost() {
    emitter.emit(EVENTS.SHOW_CREATE_POST, {
      postId: this.contentFeed.id,
      userId: this.contentFeed.userId,
    });
  }

  public onConfirmReport() {
    const baseUrl = location.origin;
    const userName = this.contentFeed.user.username;
    const postId = this.contentFeed.id;

    this.$router.push({ name: "complaints", query: { contentUrl: `${baseUrl}/${userName}?feedId=${postId}` } });
  }

  public onShareClick() {
    shareUrl(this.shareLink, $t("Link copied"));
  }
}
